import React from "react";
import { Table } from "antd";
import { InstallmentInformation as S } from "../styles";
import * as CommonS from "../styles";
import { formatDate } from "../../../utils/formatDate";
import { formatNumberToPtBr, formatPercent } from "../utils";
import { InstallmentInformationProps } from "./types";
import { columns } from "./columns";

export const InstallmentInformation: React.FC<InstallmentInformationProps> = ({
  selectedInstallmentOption,
  invoices,
  currentInvoice,
}) => {
  const dueDateValue =
    currentInvoice?.dataVencimento || invoices?.[0]?.dataVencimento;

  const infoColumns = [
    {
      key: "installment-information-first-column",
      columns: [
        {
          label: "Serviço financiado:",
          value: "FATURA",
        },
        {
          label: "Valor Financiado:",
          value: selectedInstallmentOption.valorFinanciado
            ? formatNumberToPtBr(selectedInstallmentOption.valorFinanciado)
            : undefined,
        },
        {
          label: "Vencimento:",
          value: dueDateValue,
        },
        {
          label: "Valor do Juros:",
          value: selectedInstallmentOption.valorJuros
            ? formatNumberToPtBr(selectedInstallmentOption.valorJuros)
            : undefined,
        },
      ],
    },
    {
      key: "installment-information-second-column",
      columns: [
        {
          label: "Quant. de parcelas:",
          value: selectedInstallmentOption.quantidadeParcelas,
        },
        {
          label: "Valor total:",
          value: selectedInstallmentOption.valorTotal
            ? formatNumberToPtBr(selectedInstallmentOption.valorTotal)
            : selectedInstallmentOption.valorTotal,
        },
        {
          label: "Taxa de Juros (%a.m.):",
          value: formatPercent(selectedInstallmentOption.taxaJuros),
        },
        {
          label: "Valor do Desconto:",
          value: selectedInstallmentOption.valorDesconto
            ? formatNumberToPtBr(selectedInstallmentOption.valorDesconto)
            : undefined,
        },
      ],
    },
    {
      key: "installment-information-third-column",
      columns: [
        {
          label: "Data de Ativação:",
          value: formatDate(selectedInstallmentOption.dataAtivacao),
        },
        {
          label: "Data recomendada de Ativação:",
          value: formatDate(selectedInstallmentOption.dataRecomendavelAtivacao),
        },
        {
          label: "IOF Total aplicado:",
          value: selectedInstallmentOption.valorIof
            ? formatNumberToPtBr(selectedInstallmentOption.valorIof)
            : undefined,
        },
        {
          label: "Taxa IOF Adicional (%a.m.):",
          value: formatPercent(selectedInstallmentOption.taxaIofAdicional),
        },
      ],
    },
  ];

  return (
    <>
      <CommonS.CommonSection>
        <CommonS.SectionTitle>Dados do parcelamento</CommonS.SectionTitle>
        <S.InfoGrid>
          {infoColumns.map((infoColumn) => (
            <S.InfoColumn key={infoColumn.key}>
              {infoColumn.columns.map((item) => (
                <React.Fragment key={`${infoColumn.key}-${item.label}`}>
                  <p>
                    {item.label} <strong>{item.value}</strong>
                  </p>
                </React.Fragment>
              ))}
            </S.InfoColumn>
          ))}
        </S.InfoGrid>
      </CommonS.CommonSection>
      <CommonS.CommonSection>
        <CommonS.SectionTitle>Resultado da simulação</CommonS.SectionTitle>
        <Table
          columns={columns}
          dataSource={selectedInstallmentOption.parcelas}
          pagination={false}
          scroll={{ y: 240 }}
          rowKey="quantidadeParcelas"
        />
      </CommonS.CommonSection>
    </>
  );
};
